import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { LinkOutlined } from '@ant-design/icons';

var ArticleLink = function ArticleLink(_ref) {
  var brief = _ref.brief;

  var goToLink = function goToLink(event) {
    window.open(brief.content.link, 'blank');
    event.preventDefault();
    event.stopPropagation();
    return false;
  };

  return /*#__PURE__*/_jsxs("div", {
    id: "articleLink",
    className: "fullWidth flexRow",
    onClick: goToLink,
    children: [/*#__PURE__*/_jsx("img", {
      id: "articleFavIcon",
      src: brief.content.favicon
    }), /*#__PURE__*/_jsx("span", {
      id: "articleUrl",
      children: brief.content.domain
    }), /*#__PURE__*/_jsx(LinkOutlined, {})]
  });
};

export default ArticleLink;